module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/manage/designation/designation.component.css
// module id = ./src/app/Pages/manage/designation/designation.component.css
// module chunks = main